export const API_URL = "https://digipexel.com/pvknew/webservices/public/api/";


// https://digipexel.com/pvknew/webservices/public/api/
// http://localhost/pvknew/public/api/
